angular.module('aq.services.snapshot', []).factory('SnapshotService', function ($window, $location) {
    var service: any = {};

    service.isSnapshotRequest = function() {
        return $window.navigator.userAgent === 'snapshot-service' || $location.search().snapshot;
    };

    return service;
});
